import React from 'react';

import new1 from "../img/envision/logos-to-add/logo/escad-removebg-preview.png";
import new2 from "../img/envision/logos-to-add/logo/fft-removebg-preview (1).png";
import new3 from "../img/envision/logos-to-add/logo/mldk-removebg-preview.png";
import new4 from "../img/envision/logos-to-add/logo/tyseekar-removebg-preview (1).png";

const Digitalthirdtablogs = () => {
    return (
        <div style={styles.pageContainer}>
            <div className="container mt-5 pb-5">
                <div className="row justify-content-center" style={{marginLeft:'50px'}}>
                    <div className="col-12">
                        {/* Images in a row layout */}
                       
                        {/* Repeat the row for another set of images */}
                        <div className="row">
                            <div className="col-3 mb-4 d-flex justify-content-center align-items-center">
                                <img src={new1} alt="Abb" className="img-fluid" style={styles.image} />
                            </div>
                            <div className="col-3 mb-4 d-flex justify-content-center align-items-center">
                                <img src={new2} alt="nMan" className="img-fluid" style={styles.image} />
                            </div>
                            <div className="col-3 mb-4 d-flex justify-content-center align-items-center">
                                <img src={new3} alt="Kuka" className="img-fluid" style={styles.image} />
                            </div>
                            <div className="col-3 mb-4 d-flex justify-content-center align-items-center">
                                <img src={new4} alt="Abb" className="img-fluid" style={styles.image} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

// CSS-in-JS Styles
const styles = {
    pageContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#fff', // Light background for the page
    },
    image: {
        height: '120px', // Set image height
        backgroundColor: '#fff', // Background color
        border: '1px solid #000', // Border
        margin: '0px 30px', // Horizontal margin for spacing
        width: '90%', // Set width
        borderRadius: '20px',
    },
};

export default Digitalthirdtablogs;
